// extracted by mini-css-extract-plugin
module.exports = {"timeInRoute":"timeInRoute-3ee3q","flightNumber":"flightNumber-Vccug"};